import { render, staticRenderFns } from "./PendingCustomRequests.vue?vue&type=template&id=3fe99601&scoped=true"
import script from "./PendingCustomRequests.vue?vue&type=script&lang=js"
export * from "./PendingCustomRequests.vue?vue&type=script&lang=js"
import style0 from "./PendingCustomRequests.vue?vue&type=style&index=0&id=3fe99601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe99601",
  null
  
)

export default component.exports